import React from 'react';
import { Link, withRouter } from "react-router-dom"

const Columns = ( addUpd,destroy ) => {
		let columns = [
			{
				id: 'permission_name',
				name: 'Modulo',
				selector: row => row.permission_name,
				
				wrap: true,
			},
			{
				id: 'privilege_name',
				name: 'Privilegios',
				selector: row => row.privilege_name,
				
				wrap: true,
			},
			{
				id: 'profile_name',
				name: 'Perfil',
				selector: row => row.profile_name,
				
				wrap: true,
			},
			{
				id: 'actions',
				name: 'Acciones',
				width:'10%',
				button: true,
				cell: row => (
					<div className="d-flex justify-content-between">
						<div className="p-2">
                            <button className="btn btn-warning btn-sm" title='Editar permiso' onClick={() => addUpd(row)}><i className="fas fa-edit"></i></button>
                        </div>
                		<div className="p-2">
                            <button className="btn btn-danger btn-sm" title='Eliminar permiso' onClick={() => destroy(row.id)}><i className="fas fa-trash"></i></button>
                        </div>        
					</div>
				),
			}
		];
	return columns;
}

export default Columns;